export default "__VITE_ASSET__a45c6d30__"